export default "__VITE_ASSET__D6N2Fuy1__"